import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, MessageCircleIcon, ShieldCheckIcon } from 'lucide-react';
import { ButtonAnchor, ButtonLink } from '../ui/Button';
import { PromoCarousel } from './PromoCarousel';
import { HERO_IMAGE } from '../../data/vehicles';
import { CATALOGO_URL, VCARS_BANNER } from '../../data/brand';
import { GENERAL_WA_MESSAGE, whatsappLink } from '../../utils/vehicles';
const stats = [{
  value: '+300',
  label: 'operaciones cerradas'
}, {
  value: '+500',
  label: 'clientes asesorados'
}, {
  value: '12 HS',
  label: 'promedio de respuesta'
}];
const easeOut = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <>
      {/* Presentación de marca: lo primero que ve el visitante. */}
      <motion.section aria-label="VCARS" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.4,
      ease: easeOut
    }} className="relative isolate w-full overflow-hidden bg-black" data-id="element-244" data-mp="3ryhxz8krgxk3">
        <motion.img src={VCARS_BANNER} alt="VCARS — usados seleccionados y 0KM" initial={{
        scale: 1.04
      }} animate={{
        scale: 1
      }} transition={{
        duration: 0.9,
        ease: easeOut
      }} className="h-auto w-full object-cover" data-id="element-245" data-mp="1mvt5hrwxoj22" />
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-20 md:h-32" aria-hidden="true" style={{
        background: 'linear-gradient(to top, #05070c 10%, rgba(5,7,12,0))'
      }} data-id="element-246" data-mp="1hx9j5qefh596" />
      </motion.section>

      <section className="relative isolate overflow-hidden" data-id="element-247" data-mp="2al5eaqocmp3u">
        <img src={HERO_IMAGE} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-60" data-id="element-248" data-mp="1vvzep1llmwvf" />
        <div className="absolute inset-0 bg-ink/75" aria-hidden="true" data-id="element-249" data-mp="2oly6h4r6h83s" />
        <div className="absolute inset-x-0 bottom-0 h-40 bg-ink/90" aria-hidden="true" style={{
        maskImage: 'linear-gradient(to top, black, transparent)',
        WebkitMaskImage: 'linear-gradient(to top, black, transparent)'
      }} data-id="element-250" data-mp="2ojlk8fee0bkx" />

        <div className="relative mx-auto w-full max-w-7xl px-5 pb-16 pt-12 md:px-8 md:pb-24 md:pt-20" data-id="element-251" data-mp="2y77ht5nygynk">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.28,
          delay: 0.1,
          ease: easeOut
        }} className="max-w-3xl" data-id="element-252" data-mp="2u9jmi1icp3v5">
            <p className="inline-flex items-center gap-2 rounded-full border border-neon/40 bg-neon/10 px-3 py-1.5 text-[12.5px] font-semibold text-neon-soft" data-id="element-253" data-mp="2fj2icaebzzuk">
              <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-254" data-mp="2ahmzmozmm5fc" />
              Usados seleccionados y oportunidades reales
            </p>
            <h1 className="mt-5 text-[38px] font-black leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-[64px]" data-id="element-255" data-mp="21jkqtn9ni8hi">
              Encontrá tu próximo auto con{' '}
              <span className="text-neon" data-id="element-256" data-mp="c1watn3nspmy">VCARS</span>
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/75 md:text-lg" data-id="element-257" data-mp="c1nwrrvsvea6">
              Usados seleccionados, 0KM, financiación, permutas y venta particular
              gestionada en un solo lugar.
            </p>

            <div className="mt-9 flex flex-col gap-3.5 sm:flex-row sm:flex-wrap sm:items-center" data-id="element-258" data-mp="q1f5pe7gm4hb">
              <ButtonAnchor href={CATALOGO_URL} size="xl" className="w-full sm:w-auto shadow-[0_0_0_1px_rgba(31,123,255,0.55),0_0_38px_-8px_rgba(31,123,255,1)] hover:shadow-[0_0_0_1px_rgba(31,123,255,0.85),0_0_56px_-6px_rgba(31,123,255,1)]" data-id="element-259" data-mp="3ph2c8h5awy3y">
                Ver catálogo
                <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-260" data-mp="73up0ueumc7s" />
              </ButtonAnchor>
              <ButtonLink to="/vender-mi-auto" variant="outline" size="xl" className="w-full border-neon/70 text-neon-soft shadow-[inset_0_0_24px_-14px_rgba(31,123,255,1),0_0_26px_-12px_rgba(31,123,255,0.9)] hover:text-white hover:shadow-[inset_0_0_28px_-10px_rgba(31,123,255,1),0_0_44px_-10px_rgba(31,123,255,1)] sm:w-auto" data-id="element-261" data-mp="36p9gieyukysj">
                Quiero vender mi auto
              </ButtonLink>
              <ButtonAnchor href={whatsappLink(GENERAL_WA_MESSAGE)} variant="whatsapp" size="xl" className="w-full shadow-[0_0_34px_-10px_rgba(37,194,100,0.95)] hover:shadow-[0_0_50px_-8px_rgba(37,194,100,1)] sm:w-auto" data-id="element-262" data-mp="2wluge3dbwscs">
                <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-263" data-mp="3kci3hvvtfojx" />
                Hablar con un vendedor
              </ButtonAnchor>
            </div>
          </motion.div>

          <div className="mt-16 md:mt-24" data-id="element-264" data-mp="1pxxo9yq9kl7x">
            <PromoCarousel data-id="element-265" data-mp="1pyqki5rljsbt" />
          </div>

          <dl className="mt-12 grid max-w-3xl grid-cols-3 divide-x divide-neon/25 overflow-hidden rounded-2xl border border-neon/45 bg-ink/70 backdrop-blur-md md:mt-16" style={{
          boxShadow: '0 0 0 1px rgba(31,123,255,0.18), 0 0 28px -6px rgba(31,123,255,0.55), inset 0 0 24px -12px rgba(31,123,255,0.9)'
        }} data-id="element-266" data-mp="1pzs6h5a5hz8b">
            {stats.map(s => <div key={s.label} className="px-4 py-5 text-center md:px-6 md:py-6" data-id="element-267" data-mp="3rv7q9v3q8aom">
                <dt className="sr-only" data-id="element-268" data-mp="3dvq13emiqveq">{s.label}</dt>
                <dd data-id="element-269" data-mp="3duwxunmrqo1c">
                  <span className="block text-2xl font-black tracking-tight text-neon-soft md:text-4xl" style={{
                textShadow: '0 0 18px rgba(31,123,255,0.75)'
              }} data-id="element-270" data-mp="3dxsywktwxsu0">
                    {s.value}
                  </span>
                  <span className="mt-1.5 block text-[11.5px] font-semibold uppercase leading-snug tracking-wide text-mist md:text-[12.5px]" data-id="element-271" data-mp="38xet79fsauz5">
                    {s.label}
                  </span>
                </dd>
              </div>)}
          </dl>
        </div>
      </section>
    </>;
}